import isUndefined from 'lodash-es/isUndefined'
import type { FC, MouseEventHandler } from 'react'
import React from 'react'
import { SortableElement } from 'react-sortable-hoc'
import { SortableListItemToolbar } from '../SortableListItemToolbar'
import * as S from './SortableListItem.styled'
import type { FooterListItemProps, SortableElementProps, SortableListItemProps } from './types'

const Element = SortableElement<SortableElementProps>(
  ({ children, isDragged, onRemove }: SortableElementProps) => (
    <S.Wrapper isDragged={isDragged}>
      {children}
      <S.ToolbarWrapper>
        <SortableListItemToolbar onRemove={onRemove} />
      </S.ToolbarWrapper>
    </S.Wrapper>
  ),
)

export const FooterListItem: FC<FooterListItemProps> = ({ children }) => (
  <S.Container $isLastSection data-testid="SortableListItem.Footer">
    <S.Wrapper>{children}</S.Wrapper>
  </S.Container>
)

export const SortableListItem: FC<SortableListItemProps> = ({
  index,
  isDragged,
  listHasFooter,
  children,
  onRemove,
}) => {
  if (isUndefined(index) || isUndefined(isDragged)) return null

  const handleRemove: MouseEventHandler<HTMLDivElement> = () => {
    if (onRemove) {
      onRemove(index)
    }
  }

  return (
    <S.Container $isLastSection={!listHasFooter} data-testid="SortableListItem">
      <S.Placeholder />
      <Element index={index} isDragged={isDragged} onRemove={handleRemove}>
        {children}
      </Element>
    </S.Container>
  )
}
